module.exports = __webpack_public_path__ + "static/media/JoD_Parent_Course_Intro.9814c08c.mp4";